import * as api from '../orderApi';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
  FetchOrder,
  IOrder,
  orderActionCreators,
  OrderActionKeys
  } from '..';
import { uiActionCreators } from '../../ui';

function* fetchOrderSaga(action: FetchOrder) {
  yield put(uiActionCreators.showFullPageLoading());
  const order: IOrder = yield call(api.fetchOrder, action.payload);

  yield put(uiActionCreators.hideFullPageLoading());
  yield put(orderActionCreators.fetchOrderFulfilled(order));
}

export function* watchFetchOrder() {
  yield takeEvery(OrderActionKeys.FETCH_ORDER, fetchOrderSaga);
}
